import { render, staticRenderFns } from "./MemberIntegralDetail.vue?vue&type=template&id=192bf10b&scoped=true&"
import script from "./MemberIntegralDetail.vue?vue&type=script&lang=js&"
export * from "./MemberIntegralDetail.vue?vue&type=script&lang=js&"
import style0 from "./MemberIntegralDetail.vue?vue&type=style&index=0&id=192bf10b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192bf10b",
  null
  
)

export default component.exports